import { sampleEventId } from '../fixture-ids';

export const sampleEventLegacyAlternates = {};

export const sampleEventLegacyFixtures = {
  SAMPLE_EVENT_CREATED: {
    action: 'SAMPLE_EVENT_CREATED',
    debugData: {
      id: sampleEventId,
      name: 'Checkout completed sample',
      description: 'Example payload for checkout_completed',
    },
  },
};
